export * from './index';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-translate/ng2-translate.js
// module id = 322
// module chunks = 16